<template>
    <div :class="{
            'rv-profile-update position-relative':true,
            'rv-profile-update-mobile': $detect == 'mobile'
        }">
        <div :class="{
                'profile-expired bg-white': true,
                'mb-3 px-3 py-10px': $detect == 'web',
                'p-3': $detect == 'mobile'
            }" v-if="this.data.status == 1 && this.data.status_expire === 0">
            <span class="mb-0 fs-14px text-danger">Tin rao của bạn đã hết hạn. Vui lòng gia hạn để tiếp tục sử dụng</span>
            <button class="btn btn-danger btn-sm ml-3 px-4" @click="availability()">Gia hạn ngay</button>
        </div>
        <updateWeb
            :data="data"/>
        <!-- <updateWeb
            :data="data"
            v-if="$detect == 'web'"/>
        <updateMobile v-else/> -->
    </div>
</template>
<script>
import { availability } from '@/config/raovat';
export default {
    components: {
        updateWeb: () => import('@/components/profile/raovat/update/updateWeb'),
        updateMobile: () => import('@/components/profile/raovat/update/updateMobile'),
    },
    data() {
        return {
            content: '',
            loading: false,
            id: this.$route.params.id,
            data: {},
        }
    },
    created() {
        apiGet(`/v2/profile/raovat/${this.id}`).then(res => {
            let data = res.data;
            this.data = {
                pictures: this.sortImg(data.pictures, data.picture_main),
                category: {
                    name: data.name_category,
                    id: data.id_category
                },
                poster_address: data.poster_address,
                city: {
                    name: data.name_city,
                    id: data.id_city,
                },
                price: this.$formatNumber(data.price),
                type: data.type,
                new_old: data.new_old,
                poster_name: data.poster_name,
                poster_phone: this.$formatNumberPhome(data.poster_phone),
                description: data.description,
                name: data.name,
                post_date: data.post_date,
                picture_main: data.picture_main,
                status_expire: data.status_expire,
                status: data.status,
            }

        }).catch(err => {
            if(err.status == 410){
                this.$message({
                    message: err.data.message,
                    type: 'error',
                    center: true,
                });
                this.$router.push({
                    name: 'raovat'
                })
            }
        })
    },
    methods: {
        sortImg(image, image_main){
            let img = [];
            image.map(item => {
                if(item.name === image_main){
                    img.unshift(item);
                }else{
                    img.push(item);
                }
            })
            return img;
        },
        async availability(){
            if(await availability(this.id, this)){
                this.data.status_expire = 1;
            }
        }
    }
}
</script>
<style lang="scss">
    .rv-profile-update {
        box-shadow: none !important;
        background: transparent !important;
        padding: 0 !important;
        border-radius: 0 !important;
    }
    .rv-profile-update-mobile {
        margin: -8px;
    }
    .profile-expired {
        box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }
</style>
